export class Calculation {
    ranges: Array<CalculationItem>;
    total: number;

    calculate(purchasePrice: number): void {
        this.total = 0;
        for (let i = 0; i < this.ranges.length; i++) {
            this.total += this.calculateRangeItem(purchasePrice, this.ranges[i]);
        }
        this.total = Math.round(this.total);
    }

    calculateRangeItem(purchasePrice: number, rangeItem: CalculationItem): number {
        rangeItem.rangeTotal = Math.round(this.calculateRange(purchasePrice, rangeItem) * (rangeItem.percentage / 100));

        return rangeItem.rangeTotal;
    }

    private calculateRange(purchasePrice: number, rangeItem: CalculationItem): number {
        if (purchasePrice < rangeItem.start)
            rangeItem.range = 0;
        else if (purchasePrice > rangeItem.finish) {
            rangeItem.range = rangeItem.finish - rangeItem.start;
        }

        else rangeItem.range = purchasePrice - rangeItem.start;

        return rangeItem.range;
    }
}

export class CalculationItem {
    constructor(public label: string, public percentage: number, public start: number, public finish: number) { }

    range: number;
    rangeTotal:number;
}